import { render, staticRenderFns } from "./SLStatementEmail.vue?vue&type=template&id=649670d8&"
import script from "./SLStatementEmail.vue?vue&type=script&lang=js&"
export * from "./SLStatementEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports